<template>
    <div id="mobile_search_main" class="ui segment form">
        <div class="field">
            <div class="ui search selection dropdown" id="partner_dropdown">
                <input type="hidden">
                <i class="dropdown icon"></i>
                <div class="default text">업체</div>
                <div class="menu">
                    <div class="item">전체업체</div>
                    <div class="item" v-for="p in partners" :key="p._id">{{ p.name }}</div>
                </div>
            </div>
        </div>
        <div class="field">
            <div class="ui search selection dropdown" id="worker_dropdown">
                <input type="hidden">
                <i class="dropdown icon"></i>
                <div class="default text">기사</div>
                <div class="menu">
                    <div class="item">전체기사</div>
                    <div class="item" v-for="w in workers" :key="w._id">{{ w.name }}</div>
                </div>
            </div>
        </div>
        <div class="field">
            <div class="ui calendar" id="calendar">
                <div class="ui input left icon">
                    <i class="calendar icon"></i>
                    <input type="text" placeholder="날짜">
                </div>
            </div>
        </div>
        <div class="field">
            <div class="ui input left icon">
                <i class="user icon"></i>
                <input type="text" placeholder="주문자" v-model="filter.orderer" @change="search()">
            </div>
        </div>
        <div class="field">
            <div class="ui input left icon">
                <i class="phone icon"></i>
                <input type="text" placeholder="주문자 전화번호" v-model="filter.ordererTel" @change="search()">
            </div>
        </div>
        <div id="ordered_items" v-if="orderedItems.length > 0">
            <h2 class="ui header">
                <i class="circular truck icon"></i>{{ "진행건" }}
            </h2>
            <div class="ui styled accordion">
                <div v-for="(item) in orderedItems" :key="item._id">
                    <div class="title">
                        {{ new Date(item.orderedAt).format("yyyy-MM-dd(KS)") }} | {{ item.orderer }} | {{ item.ordererTel }}
                    </div>
                    <div class="content">
                        <p>{{ item.partnerName }}</p>
                        <p>{{ item.address }}</p>
                        <p>{{ item.product }} {{ item.count }}개</p>
                        <p>{{ item.partnerMemo }}</p>
                        <p>{{ item.comment }}</p>
                        <button class="ui teal button" @click="openOrderedItem(item)">
                            상세보기
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div id="finished_items" v-if="finishedItems.length > 0">
            <h2 class="ui header">
                <i class="circular handshake icon"></i>{{ "완료 & 취소건" }}
            </h2>
            <div class="ui styled accordion" v-if="finishedItems.length > 0">
                <div v-for="(item) in finishedItems" :key="item._id">
                    <div class="title">
                        {{ new Date(item.createdAt).format("yyyy-MM-dd(KS)") }} | {{ item.orderer }} | {{ item.ordererTel }}
                    </div>
                    <div class="content">
                        <p>{{ item.partnerName }}</p>
                        <p>{{ item.address }}</p>
                        <p>{{ item.product }} {{ item.count }}개</p>
                        <p>{{ item.partnerMemo }}</p>
                        <p>{{ item.comment }}</p>
                        <button class="ui teal button" @click="openFinishedItem(item)">
                            상세보기
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div id="parcel_items" v-if="parcelItems.length > 0">
            <h2 class="ui header">
                <i class="circular archive icon"></i>{{ "택배건" }}
            </h2>
            <div class="ui styled accordion">
                <div v-for="(item) in parcelItems" :key="item._id">
                    <div class="title">
                        {{ new Date(item.orderedAt).format("yyyy-MM-dd(KS)") }} | {{ item.orderer }} | {{ item.ordererTel }}
                    </div>
                    <div class="content">
                        <p>{{ item.partnerName }}</p>
                        <p>{{ item.address }}</p>
                        <p>{{ item.product }} {{ item.count }}개</p>
                        <button class="ui teal button" @click="openParcelItem(item)">
                            상세보기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const moment = require("moment");

export default {
    data: function() {
        return {
            filter: 0,
            orderedItems: 0,
            finishedItems: 0,
            parcelItems: 0,
        }
    },
    created: function() {
        this.filter = {};
        this.orderedItems = [];
        this.finishedItems = [];
        this.parcelItems = [];
    },
    mounted: function() {
        this.$ui.calendar("#calendar", (date, text) => { this.filter.date = text; this.search(); });
        this.$ui.dropdown("#partner_dropdown", (text) => { this.filter._partner = this.findUserId(text); this.search(); });
        this.$ui.dropdown("#center_dropdown", (text) => { this.filter._center = this.findUserId(text); this.search(); });
        this.$ui.dropdown("#worker_dropdown", (text) => { this.filter._worker = this.findUserId(text); this.search(); });
        this.$ui.dropdown("#product_dropdown", (text) => { this.filter.product = this.findProductName(text.toUpperCase()); this.search(); });
        this.$nextTick(() => {
            this.$event.call("closeLoading");
        });
    },
    methods: {
        findUserId(userName) {
            for (const user of this.partners) { if (user.name == userName) return user._id; }
            for (const user of this.centers) { if (user.name == userName) return user._id; }
            for (const user of this.workers) { if (user.name == userName) return user._id; }
            return undefined;
        },
        findProductName(productName) {
            for (var product of this.products) {
                if (product.name == productName) {
                    return product.name;
                }
            }
            return undefined;
        },
        search() {
            if (this.filter.ordererTel) {
                const ordererTel = this.filter.ordererTel.replace(/[^0-9]/g, "");
                switch (ordererTel.length) {
                    default: this.filter.ordererTel = ordererTel; break;
                    case 7: this.filter.ordererTel = ordererTel.substring(0, 3) + "-" + ordererTel.substring(3, 7); break;
                    case 8: this.filter.ordererTel = ordererTel.substring(0, 4) + "-" + ordererTel.substring(4, 8); break;
                    case 9: this.filter.ordererTel = ordererTel.substring(0, 2) + "-" + ordererTel.substring(2, 5) + "-" + ordererTel.substring(5, 9); break;
                    case 10: this.filter.ordererTel = ordererTel.substring(0, 3) + "-" + ordererTel.substring(3, 6) + "-" + ordererTel.substring(6, 10); break;
                    case 11: this.filter.ordererTel = ordererTel.substring(0, 3) + "-" + ordererTel.substring(3, 7) + "-" + ordererTel.substring(7, 11); break;
                }
            }

            this.$event.call("openLoading");
            this.$api.searchItems(this.filter, (resData) => {
                this.$event.call("closeLoading");

                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.orderedItems = resData.orderedItems;
                    this.finishedItems = resData.finishedItems;
                    this.parcelItems = resData.parcelItems;

                    this.$nextTick(() => {
                        this.$ui.accordion('.ui.accordion');
                    });
                }
            });
        },
        getCenterName(_centerId) {
            for (var center of this.centers) {
                if (center._id === _centerId) {
                    return center.name;
                }
            }
            return "";
        },
        getWorkerName(_workerId) {
            for (var worker of this.workers) {
                if (worker._id == _workerId) {
                    return worker.name;
                }
            }
            return "";
        },
        openOrderedItem(item) {
            this.$event.call("orderedItemDetail_open", item._id, this.search);
        },
        openFinishedItem(item) {
            this.$event.call("finishedItemDetail_open", item._id, this.search);
        },
        openParcelItem(item) {
            this.$event.call("parcelItemDetail_open", item._id, this.search);
        },
        getOrderedColor(item) {
            if (item.isCanceled) { return "red"; }
            switch (item.status) {
                default: return "";
                // case this.STATUS_READY: return "yellow";
                case this.STATUS_APPOINTED: return "yellow";
                case this.STATUS_STARTED: return "blue";
            }
        },
    },
    computed: {
        isHeader: function() { return this.$store.getters.isHeader; },
        isPartner: function() { return this.$store.getters.isPartner; },
        isCenter: function() { return this.$store.getters.isCenter; },
        partners: function() { return this.$store.getters.partners; },
        centers: function() { return this.$store.getters.centers; },
        workers: function() { return this.$store.getters.workers; },
        products: function() { return this.$store.getters.products; },
        constant: function() { return this.$store.getters.constant; },
        constantNames: function() { return this.$store.getters.constantNames; },
        STATUS_READY: function() { return this.$store.getters.constant.STATUS_READY; },
        STATUS_APPOINTED: function() { return this.$store.getters.constant.STATUS_APPOINTED; },
        STATUS_STARTED: function() { return this.$store.getters.constant.STATUS_STARTED; },
        STATUS_CANCEL: function() { return this.$store.getters.constant.STATUS_CANCEL; },
    },
};
</script>

<style>
#mobile_search_main {
    width: 100%;
    overflow: auto;
}

#mobile_search_main .ui.accordion {
    text-align: left;
}

#mobile_search_main .ui.grid {
    padding-bottom: 10px;
}

#mobile_search_main .ui.grid .ui.dropdown {
    margin-top: 3px;
}

</style>


// WEBPACK FOOTER //
// src/components/Mobile_SearchMain.vue